function windowDevicePixelRatio() {
  return window.devicePixelRatio;
}

export { windowDevicePixelRatio };